const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      const formEmbedElement = document.querySelector('form-embed');
      if (formEmbedElement) {
        const shadowRoot = formEmbedElement.shadowRoot;
        if (shadowRoot) {
          const formElement = shadowRoot.querySelector('._formFieldset_1ll8d_67');
          if (formElement) {
            const formFieldContainers = formElement.querySelectorAll('._formFieldContainer_1ydxd_5');
            const formSelector = formElement.querySelectorAll('._selectContainer_1yit2_6');
            const correoField = formElement.querySelector('#email'); // Campo correo
            
            const formButtonFields = formElement.querySelectorAll('button._formSubmitButton_1ll8d_81');
            const ciudad =formElement.querySelectorAll('input._formInputField_237zm_7');
            const departamento =formElement.querySelector('._label_1yit2_10');


            // Orientar texto de departamento y asignarle color
              departamento.style.cssText = `
              color:#20202080;
              margin-left:10px;
                
              `;
            
            // Darle estilo al input de ciudad y actividad economica para que tome el 100% del div
            ciudad.forEach(ciudad => {
              ciudad.style.cssText = `
              height:100%
                
              `;
            });
            
            // Asegúrate de que el contenedor permita flexibilidad
            formElement.style.cssText = `
              display: flex;
              gap: 10px;
              flex-wrap: wrap; /* Permite que los elementos se acomoden en filas */
              flex-direction: row;
            `;


            // Ajusta los contenedores
            formFieldContainers.forEach(container => {
              container.style.cssText = `
                flex: 1;
                color: #CDDE00;
                border: 1px solid #CDDE00;
                min-width: 48%; /* Permite que dos elementos ocupen 50% del espacio */
                box-sizing: border-box;
              `;
            });

            // Ajusta el selector de ciudades o departamentos
            formSelector.forEach(container => {
              container.style.cssText = `
                border: 1px solid #CDDE00;
                flex: 1;
              `;
            });

            // Asegúrate de que el campo de correo ocupe toda la fila
            if (correoField) {
              const correoContainer = correoField.closest('._formFieldContainer_1ydxd_5');
              if (correoContainer) {
                correoContainer.style.cssText = `
                  width: 100%; /* Ocupa toda la fila */
                `;

                correoField.style.cssText = `
                  border: 1px solid #CDDE00;
                `;
              }
            }

            // Ajusta el botón de envío para centrarlo y ocupar su espacio
            formButtonFields.forEach(button => {
              button.style.cssText = `
                width: 200px; /* Tamaño del botón */
                font-weight: 800;
                text-align:center;
                margin: 15px auto; /* Centra el botón horizontalmente */
                display: block; /* Asegura que esté en su propia fila */
              `;
            });
          }
        }
      }
    }
  });
});

// Configurar el observador
observer.observe(document.body, { childList: true, subtree: true });